import type { ReactElement } from "react";

import { Body } from "@/components/Text";
import type { BodyProps, InputTextAlign } from "@/types";
import { mergeSx } from "@/utils";

type InputListCaptionProps<RC extends ReactElement | undefined = undefined> =
  BodyProps<RC> & { textAlign?: InputTextAlign };

export function InputListCaption<
  RC extends ReactElement | undefined = undefined,
>({
  size = "small",
  className,
  sx,
  textAlign,
  testId = "InputListCaption",
  ...props
}: InputListCaptionProps<RC>) {
  return (
    <Body
      {...props}
      size={size}
      testId={testId}
      className={`${className ?? ""} InputListCaption`}
      sx={mergeSx(
        {
          c: "base.color.text.body.secondary",
          mt: "base.spacing.x2",
          py: "base.spacing.x2",
          textAlign: textAlign ?? "left",
        },
        sx,
      )}
    />
  );
}

InputListCaption.displayName = "InputList.Caption";
